import { Link } from "@/components/LocalLink";
import { PageShell, usePageMeta } from "@/components/PageShell";

const POINTS = [
  ["On their schedule", "A jar arrives when the last one runs out, timed to your dog's daily measure."],
  ["Skip, pause or cancel", "From your account, whenever you like. No phone calls, no forms."],
  ["About 10% less", "Each Standing Order jar costs about 10% below the one-jar price."],
];

export default function StandingOrders() {
  usePageMeta("Standing Orders · coming soon | Dirty Paws Apothecary", "Standing Orders are coming soon: timed refills of your dog's jar that you can skip, pause or cancel from your account.");
  return (
    <PageShell testid="standing-orders-page" page="help" closing>
      <div className="wrap">
        <div className="page-head">
          <div className="eyebrow">Standing Orders</div>
          <h1>Coming soon.</h1>
          <p>Standing Orders aren't open yet. When they open, a jar will arrive on your dog's schedule, about 10% below the one-jar price, and you'll be able to skip, pause or cancel from your account.</p>
        </div>
        <div className="topics so-points" data-testid="standing-points">
          {POINTS.map(([h, p], i) => <div key={h} className="panel topic"><div className="eyebrow">0{i + 1}</div><h4>{h}</h4><p>{p}</p></div>)}
        </div>
        <div style={{ display: "flex", gap: 14, flexWrap: "wrap", marginTop: 30 }}>
          <Link to="/shop" className="btn btn-primary" data-testid="standing-shop">Shop the jars</Link>
          <Link to="/help#standing-orders" className="btn btn-ghost" data-testid="standing-help">Read the details</Link>
        </div>
      </div>
    </PageShell>
  );
}
